import { Component, Input, ChangeDetectionStrategy, HostBinding } from '@angular/core';
import { AbstractControl, UntypedFormControl } from '@angular/forms';

export interface InputValidationWrapConfig {
  inputWithSecondIcon?: boolean;
}

@Component({
  standalone: false,
  selector: 'ti-input-validation-wrap',
  templateUrl: './input-validation-wrap.component.html',
  styleUrls: ['./input-validation-wrap.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputValidationWrapComponent {
  @Input() control: UntypedFormControl | AbstractControl;
  @Input() config: InputValidationWrapConfig;
  @Input() firstSubmit: boolean;

  @HostBinding('class.is-valid') get isValid() {
    return !this.firstSubmit && this.control && this.control.valid;
  }
  @HostBinding('class.is-invalid') get isInvalid() {
    return !this.firstSubmit && this.control && this.control.invalid;
  }
}
